import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconMap = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-map' + (className ? ` ${className}` : '')}
            fill='none'
            height='13'
            viewBox='0 0 14 13'
            width='14'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M8.68104 12.9054L4.08333 11.5352L0.874375 12.5804C0.760486 12.6176 0.654305 12.6268 0.555833 12.6079C0.4575 12.589 0.365069 12.5481 0.278542 12.4852C0.192014 12.4223 0.123958 12.3442 0.0743752 12.251C0.0247918 12.158 0 12.0561 0 11.9454V1.98833C0 1.77792 0.0579862 1.59055 0.173958 1.42625C0.289792 1.2618 0.434306 1.15021 0.6075 1.09146L3.67313 0.0625C3.73521 0.0347222 3.80389 0.0173611 3.87917 0.0104167C3.95444 0.00347222 4.0225 0 4.08333 0C4.14417 0 4.21222 0.00347222 4.2875 0.0104167C4.36278 0.0173611 4.43146 0.0347222 4.49354 0.0625L9.08333 1.43271L12.2923 0.3875C12.4062 0.350277 12.5124 0.34111 12.6108 0.359999C12.7092 0.378888 12.8016 0.419791 12.8881 0.482708C12.9747 0.545625 13.0427 0.62368 13.0923 0.716874C13.1419 0.80993 13.1667 0.911805 13.1667 1.0225V11.0154C13.1667 11.2263 13.1082 11.4166 12.9913 11.5865C12.8742 11.7563 12.7195 11.8637 12.5273 11.9085L9.48563 12.9133C9.42146 12.9411 9.35285 12.9572 9.27979 12.9615C9.20674 12.9658 9.14104 12.9679 9.08271 12.9679C9.02437 12.9679 8.95889 12.9644 8.88625 12.9575C8.81361 12.9506 8.74521 12.9332 8.68104 12.9054ZM8.54167 11.7565V2.38146L4.625 1.19542V10.5704L8.54167 11.7565ZM9.625 11.7148L12.0833 10.9006V1.56729L9.625 2.38146V11.7148ZM1.08333 11.4006L3.54167 10.5704V1.23708L1.08333 2.06729V11.4006Z'
                fill={fill} />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconMap;
